import { FormGridField } from "../../components/FormGrid";

export interface TextAreaDefinition {
    name: string;
    id: string;
    label: string;
    text?: string;
    placeholder?: string;
    disabled?: boolean;
    schemaName?: string;
    fieldOverrides?: any;
    buildFormGridField: (_schema) => FormGridField;
}

export default function buildTextAreaDefinition({
    name,
    id,
    label,
    text,
    disabled,
    schemaName,
    placeholder,
    fieldOverrides
}: {
    name: string;
    id: string;
    label: string;
    text?: string;
    disabled?: boolean;
    schemaName?: string;
    placeholder?: string;
    fieldOverrides?: any;
}): TextAreaDefinition {
    return {
        name,
        id,
        label,
        text,
        disabled,
        schemaName,
        placeholder,
        fieldOverrides,
        buildFormGridField: _createTextArea
    };
}

function _createTextArea(schema): FormGridField {
    const {
        name,
        id,
        label,
        disabled,
        text,
        schemaName,
        placeholder,
        fieldOverrides
    } = this;
    const { columnClass } = fieldOverrides;

    let newItem = {
        name,
        fieldType: "textarea",
        fieldOptions: {
            id,
            label,
            value: text,
            disabled,
            placeholder: placeholder,
            classNames: columnClass
        },
        columnClass: "col-12",
        formSpacing: true,
        ...fieldOverrides
    };

    if (schema) {
        newItem["validationSchema"] = {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        };
    }

    return newItem;
}
